import { useState } from 'react';

import {
  type ExportCol,
  exportCsv,
  exportExcel,
  exportPdf,
} from '../lib/export';
import { Btn } from './Btn';

interface Props<T> {
  rows: T[];
  cols: ExportCol<T>[];
  filename: string;
  title: string;
  pdf?: boolean;
  label?: string;
}

export function ExportMenu<T>({
  rows,
  cols,
  filename,
  title,
  pdf = false,
  label = 'ส่งออก',
}: Props<T>) {
  const [open, setOpen] = useState(false);
  const choose = (fmt: 'excel' | 'csv' | 'pdf') => {
    setOpen(false);
    if (fmt === 'excel') void exportExcel(filename, rows, cols);
    else if (fmt === 'csv') void exportCsv(filename, rows, cols);
    else void exportPdf(filename, title, rows, cols);
  };
  return (
    <div className="relative">
      <Btn
        kind="default"
        onClick={() => setOpen((o) => !o)}
        aria-haspopup="menu"
        aria-expanded={open}
      >
        {label} ▾
      </Btn>
      {open && (
        <>
          <div
            className="fixed inset-0 z-0"
            onClick={() => setOpen(false)}
            aria-hidden="true"
          />
          <div
            role="menu"
            className="absolute right-0 mt-1 w-40 bo-card p-1 z-10"
          >
            <button
              role="menuitem"
              onClick={() => choose('excel')}
              className="block w-full text-left px-3 py-2 text-body rounded-btn hover:bg-bg-warm"
            >
              Excel (.xlsx)
            </button>
            <button
              role="menuitem"
              onClick={() => choose('csv')}
              className="block w-full text-left px-3 py-2 text-body rounded-btn hover:bg-bg-warm"
            >
              CSV
            </button>
            {pdf && (
              <button
                role="menuitem"
                onClick={() => choose('pdf')}
                className="block w-full text-left px-3 py-2 text-body rounded-btn hover:bg-bg-warm"
              >
                PDF
              </button>
            )}
          </div>
        </>
      )}
    </div>
  );
}
